import { ExtraLearningContent } from './/ExtraLearningContent';
export default ExtraLearningContent;